import { useWatch } from 'react-hook-form';
import { BaseOption } from 'components/forms/multiSelectField/MultiSelectField.types';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';

const useSearchedScheduledMessage = (): string | undefined => {
  const searchedScheduledMessaged:
    | ScheduledMessage[]
    | BaseOption[]
    | undefined = useWatch({
    name: 'scheduledMessageSearch',
  });

  if (!searchedScheduledMessaged?.length) {
    return undefined;
  }

  const [chosenScheduledMessage] = searchedScheduledMessaged;

  return 'label' in chosenScheduledMessage
    ? chosenScheduledMessage.label
    : chosenScheduledMessage.messageName;
};

export default useSearchedScheduledMessage;
